import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CreativeUnitPackageDto } from '../../../../../../api/src/creative-unit-package/models/creative-unit-package.dto';

export interface CreativeUnitPackageState extends EntityState<CreativeUnitPackageDto, string>, ActiveState {
	versionList: CreativeUnitPackageDto[];
	editor: {
		activeCreativeUnitId: string;
	};
}

const initialState = {
	versionList: [],
	editor: {
		activeCreativeUnitId: null
	}
};

@Injectable({ providedIn: 'root' })
@StoreConfig({
	name: 'ad'
})
export class CreativeUnitPackageStore extends EntityStore<CreativeUnitPackageState> {
	constructor() {
		super(initialState);
	}
	setVersionList(versions: CreativeUnitPackageDto[]) {
		this.update({ versionList: versions });
	}

	addToVersionList(version: CreativeUnitPackageDto) {
		const current = this.getValue().versionList;
		this.update({ versionList: [...current, version] });
	}
	updateVersionListItem(version: CreativeUnitPackageDto) {
		const current = this.getValue().versionList.filter(x => x.id !== version.id);
		const updatedList = [...current, version];

		// Sort by modified (latest first)
		updatedList.sort((a, b) => new Date(b.modified).getTime() - new Date(a.modified).getTime());

		this.update({ versionList: updatedList });
	}
}
